import CryptoJS from 'crypto-js';
import axios from 'axios';
import { postApi } from '../../lib/fetcher';

const detailDuplicateMid = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      totalPage: 0,
      loading: false,
      errors: [],
      flashError: false,
      flashErrorMessage: '',
      requestData: null,
    };
  },
  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },
    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },
    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },
    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },
    clearErrors(state) {
      state.errors = [];
    },
    setErrors(state, payload) {
      state.errors = payload;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setCancelation(state, payload) {
      state.requestData = payload;
    },
  },

  actions: {
    async getData(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search, mid }
    ) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sortbyData = `${sortBy[0] ? sortBy[0] : 'stock_mid'} ${sort}`;

      const data = JSON.stringify({
        mid,
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sortBy: sortbyData,
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/mid/duplicate-mid/view`;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == '200') {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },
  },
};

export default detailDuplicateMid;
